import { createSlice } from "@reduxjs/toolkit";

const CardSlice = createSlice({
  name: "cards",
  initialState: {
    cardExisted: "1",
    customerTab: "profile",
    advisorTab: "profile",
    subadvisorTab: "profile",
  },
  reducers: {
    changeCardTrue: (state, action) => {
      state.cardExisted = action.payload; // Add document ID
    },
    changeCardFalse: (state) => {
      state.cardExisted = "1"; // Reset state to an empty array
    },
    changeCustomerTabTrue: (state, action) => {
      state.customerTab = action.payload; // Add document ID
    },
    changeCustomerTabFalse: (state) => {
      state.customerTab = "profile"; // Reset state to an empty array
    },
    changeAdvisorTabTrue: (state, action) => {
      state.advisorTab = action.payload; // Add document ID
    },
    changeAdvisorTabFalse: (state) => {
      state.advisorTab = "profile"; // Reset state to an empty array
    },
    changeSubAdvisorTabTrue: (state, action) => {
      state.subadvisorTab = action.payload; // Add document ID
    },
    changeSubAdvisorTabFalse: (state) => {
      state.subadvisorTab = "profile"; // Reset state to an empty array
    },
  },
});

export const {
  changeCardTrue,
  changeCardFalse,
  changeCustomerTabTrue,
  changeCustomerTabFalse,
  changeAdvisorTabTrue,
  changeAdvisorTabFalse,
  changeSubAdvisorTabTrue,
  changeSubAdvisorTabFalse,
} = CardSlice.actions;

export default CardSlice.reducer;
